import { render, staticRenderFns } from "./OpenWaterView.vue?vue&type=template&id=130b0068&"
import script from "./OpenWaterView.vue?vue&type=script&lang=js&"
export * from "./OpenWaterView.vue?vue&type=script&lang=js&"
import style0 from "./OpenWaterView.vue?vue&type=style&index=0&id=130b0068&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports